// extracted by mini-css-extract-plugin
export var itemVariant__industries = "s-module--itemVariant__industries--49cb7";
export var itemVariant__locations = "s-module--itemVariant__locations--cc038";
export var itemVariant__perks = "s-module--itemVariant__perks--8cd4a";
export var multiItemBlock = "s-module--multiItemBlock--8d650";
export var multiItemBlockContent = "s-module--multiItemBlockContent--50f6c";
export var multiItemBlockDescription = "s-module--multiItemBlockDescription--c3f32";
export var multiItemBlockTitle = "s-module--multiItemBlockTitle--d8435";